import { makeObservable, observable } from "mobx";
import { ConversationStatus, ImConversation } from "@whatslly/types/tuvis-messaging/TuvisMessagingConversations";

export class IMConversation implements ImConversation {
  _id: string;
  orgId: string;
  chatId: string;
  phoneId: string;
  phone: number;
  status: ConversationStatus;
  closedAt: Date | undefined;
  closedBy: string | undefined;
  lastMessageAt: Date | undefined;
  assignedAgentIds: string[] | undefined;
  createdAt: string;
  updatedAt: string;

  constructor(data: ImConversation) {
    const toDate = (value: unknown): Date | undefined => {
      if (value == null) return undefined;
      if (value instanceof Date) return value;
      if (typeof value === "string" || typeof value === "number") return new Date(value);
      if (typeof value === "object") return new Date(String(value));
      return undefined;
    };
    this._id = data._id;
    this.orgId = data.orgId;
    this.chatId = data.chatId;
    this.phoneId = data.phoneId;
    this.phone = data.phone;
    this.status = data.status;
    this.closedAt = toDate(data.closedAt);
    this.closedBy = data.closedBy;
    this.lastMessageAt = toDate(data.lastMessageAt);
    this.assignedAgentIds = data.assignedAgentIds;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;

    makeObservable(this, {
      status: observable,
      assignedAgentIds: observable,
      closedAt: observable,
      closedBy: observable,
      lastMessageAt: observable,
    });
  }
}
